<template>
  <div class="juries">
    <img
      src="@/assets/images/juries/hero_2.jpg"
      alt="DiDi Shark Tank"
      class="juries__hero"
    />
    <h2>Conoce a nuestros jurados</h2>

    <div class="juries__item">
      <img src="@/assets/images/juries/veneta.png" alt="DiDi Shark Tank" />
      <div class="content">
        <h4>Veneta Stefanova Andonova, Ph.D.</h4>
        <p>
          Decana de la Facultad de Administración de la Universidad de los
          Andes. Ph.D. y MSc. en Management de la Universidad Pompeu-Fabra, y
          Administradora de la Universidad de Sofía en Bulgaria. Adicionalmente,
          es miembro fundador de Emerging Markets Research Network (EMRN). Es
          autora de los libros Multilatinas: Strategies for internationalization
          (2017) y Entrepreneurial Ecosystems in Unexpected Places (2019). Parte
          del curso MOOC Hacer negocios con multinacionales y empresas en
          América Latina, disponible en Coursera.
        </p>
      </div>
    </div>

    <div class="juries__item">
      <img src="@/assets/images/juries/jorgeo.png" alt="DiDi Shark Tank" />
      <div class="content">
        <h4>Jorge Ordóñez</h4>
        <p>
          Ingeniero Industrial de la Universidad de los Andes y MBA de INSEAD en
          Francia, con experiencia en la industria aeronáutica y en consultoría
          estratégica. Ha trabajado en temas de Estrategia Corporativa, diseño
          organizacional, transformación y experiencia de usuarios, fusiones y
          adquisiciones, entre otros. Actualmente es el Gerente de Operaciones
          para Colombia, Centroamérica y Caribe de DiDi y ha ocupado varias
          posiciones en la compañía en los últimos años en las áreas de
          operaciones y planeación estratégica.
        </p>
      </div>
    </div>

    <div class="juries__item">
      <img src="@/assets/images/juries/isaac.jpg" alt="DiDi Shark Tank" />
      <div class="content">
        <h4>Isaac Prada y Nogueira, Ph.D.</h4>
        <p>
          Doctor Ingeniero Industrial, empresario, premio Mejor Emprendedor 2016
          (KeelWit Technology) y y mentor de competitividad para empresas con un
          método basado en la Fórmula 1. Ya ha trabajado con multinacionales
          como Repsol, Iberdrola, Banco Santander o Bosch y con PYMES y
          trabajadores independientes de diferentes sectores. <br />
          <br />

          Ha fundado empresas de ingeniería, tecnología, ocio y formación
          ejecutiva y ahora está expandiendo su negocio en Latinoamérica en el
          campo de la formación sobre productividad y gestión de negocios para
          PYMES e independientes con el método que ha desarrollado con base en
          lo que aprendió como ingeniero en la Fórmula 1. Divulgador apasionado,
          comparte cada día contenido sobre emprendimiento y competitividad en
          su canal de YouTube.
        </p>
      </div>
    </div>

    <h2>Conoce a nuestro panel de expertos</h2>

    <div class="juries__item">
      <img src="@/assets/images/juries/jorge.png" alt="DiDi Shark Tank" />
      <div class="content">
        <h4>Jorge Alberto Hernández Mora</h4>
        <p>
          Profesor de la Facultad de Administración de la Universidad de los
          Andes y uno de los miembros del Nodo de Innovación: el núcleo de
          profesores uniandinos que busca integrar la academia y la industria a
          través de la innovación, particularmente a través de sus dos programas
          de posgrado: la maestría y el doctorado en Gestión de la Innovación
          Tecnológica. Arquitecto de La Universidad Piloto de Colombia y
          Executive MBA de la Universidad de Los Andes. Columnista de Innovación
          de la Casa editorial El Tiempo.
        </p>
      </div>
    </div>

    <div class="juries__item">
      <img src="@/assets/images/juries/andres.png" alt="DiDi Shark Tank" />
      <div class="content">
        <h4>Andrés Jose Guerrero Alvarado</h4>
        <p>
          Director del Centro de Emprendimiento, Economista, Universidad de los
          Andes, 1995. Master in Environmental Economics and Natural Resources,
          University of Maryland, 1996. Master of Management, Tulane University,
          2015.
        </p>
      </div>
    </div>

    <div class="juries__item">
      <img src="@/assets/images/juries/alvaro.png" alt="DiDi Shark Tank" />
      <div class="content">
        <h4>Álvaro Felipe Pacheco Malaver</h4>
        <p>
          Ingeniero Industrial y MBA de la Universidad de los Andes.
          Líder-Fundador, Ejecutor de Startup e Innovación Corporativa, Profesor
          de cátedra en emprendimiento. Experiencia corporativa previa en Banca,
          enfoque en Mercados y Banca Corporativa y de Inversión. Fue Fundador
          de laspartes.com. Trabajó como broker y analista de la banca de
          inversión corporativa en el BBVA y Banco Santander.
        </p>
      </div>
    </div>

    <Allies />
  </div>
</template>

<script>
import Allies from "@/components/Allies.vue";
export default {
  components: { Allies },
};
</script>

<style lang="scss" scoped>
.juries {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: url("../assets/images/bg.jpg") no-repeat;
  background-size: cover;

  &__hero {
    width: 100%;
  }

  h2 {
    color: white;
    text-transform: uppercase;
    margin: 4rem 0;

    @include phone {
      text-align: center;
      width: 90%;
      margin: 2rem 0;
    }
  }

  &__item {
    width: 75%;
    display: grid;
    grid-template-columns: 1fr 4fr;
    column-gap: 2rem;
    margin-bottom: 4rem;

    @include phone {
      display: flex;
      flex-direction: column;
      width: 85%;
    }

    img {
      border-radius: 50%;
      width: 230px;
      height: 230px;
      object-fit: cover;

      @include phone {
        width: 200px;
        height: 200px;
        margin-bottom: 1rem;
      }
    }

    .content {
      display: flex;
      flex-direction: column;
      font-family: "Montserrat", sans-serif;
      h4 {
        color: $main-color;
        font-size: 1.5rem;
        margin-bottom: 1rem;

        @include phone {
          font-size: 1rem;
        }
      }
      p {
        color: white;
        line-height: 1.4em;
      }
    }

    &:last-of-type {
      margin-bottom: 10rem;
    }
  }
}
</style>